import * as React from 'react';
import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';
import { getEstimationFiltersHash } from '../../selectors/estimation';
import { selectPageType } from '../../selectors/page';
import { EPageType } from '../../types/redux/page';
import { selectHouseId } from '../../selectors/filters';
import { EPageTypes } from '../../constants/page';

export interface ITrackUserDisagreeParams {
  houseId: number;
  category: EPageTypes;
}

function trackUserDisagree({ houseId, category }: ITrackUserDisagreeParams) {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'user_estimate_send',
    label: `disagree/${houseId}`,
  });
}

/**
 * Отправляет событие по клику на кнопку "Не согласен с оценкой"
 * делает это 1 раз на 1 адрес
 */
export function useTrackUserDisagree() {
  const [isSend, setIsSend] = React.useState(false);
  // На этом этапе houseId точно будет, так как без него не будет доступен этот блок
  const houseId = useSelector(selectHouseId) as number;
  const pageType = useSelector(selectPageType);
  const estimationHash = useSelector(getEstimationFiltersHash);
  const category = pageType === EPageType.ReportCreator ? EPageTypes.EstateCalculatorB2B : EPageTypes.EstateCalculator;

  React.useEffect(() => {
    setIsSend(false);
  }, [estimationHash]);

  return React.useCallback(() => {
    if (isSend) {
      return;
    }

    setIsSend(true);
    trackUserDisagree({ houseId, category });
  }, [isSend, houseId, category]);
}
